module.exports = () ->
  return {
    restrict: 'A'
    replace: true
    scope:
      item: '='
      label: '='
      selectOne: '='
      toggle: '='
      selectionEnabled: '='
      isSelected: '='
      shouldShowSourceCounts: '='
      only: '='

    controller: ($scope) ->

############
# SCOPE
############

# Make sure we have sensible defaults
      if not angular.isDefined($scope.selectionEnabled)
        $scope.selectionEnabled = true

      $scope.item = $scope.item || {}
      $scope.label = $scope.label || 'item'


    template: require('./multi-select-facet-item.html')
  }
